import { useAnalyticsErrorPageTracker } from '@cp-shared-19/frontend-ui';
import { ErrorPage } from 'components/error-page';
import React from 'react';

export const NotFoundPage: React.FC = () => {
    useAnalyticsErrorPageTracker('notFoundError');
    return <ErrorPage type="not-found-error" />;
};
